import React from 'react';
import * as fileCrud from '../../../../crud/file.crud';
import Document from '../../_CustomComponents/DocumentV2';
import BaseDocument from '../../_CustomComponents/BaseDocument';
import { Alert } from "react-bootstrap";
import BiDynamicForm from '../../../../partials/layout/BiDynamicForm';
import { Validator, CustomRule, } from 'devextreme-react/validator';
import { CheckBox } from 'devextreme-react/check-box';
import moment from 'moment';
import { FormattedMessage, injectIntl } from "react-intl";
import DocumentDraftInfo from '../../_CustomComponents/DocumentDraftInfo';

class ReplyDocument extends BaseDocument {
    constructor(props) {
        super(props);
        const { replyFields } = this.props.workflowItem;

        this.rejectOptions = replyFields.RejectReasons.rejectOptions;
        this.rejectOptions = this.rejectOptions.map(opt => ({ ...opt, validatorRef: React.createRef() }));



        const initialOptions = this.rejectOptions.reduce((obj, option) => ({ ...obj, [option.field]: props.reply[option.field] }), {});

        this.replyFormConfig = {
            fields: [
                { label: replyFields.Status.label, dataField: 'status', editorType: 'dxSelectBox', editorOptions: { dataSource: replyFields.Status.replyOptions, valueExpr: 'field', displayExpr: 'display' } },
                { label: replyFields.RejectReasons.label, render: this.renderCheckboxes, visible: (obj) => ["Not Accepted", "NOT_ACCEPTED", "NOT_ACCEPTED_RESUBMIT"].includes(obj.status), },
                { label: replyFields.Comments.label, dataField: 'comments', editorType: 'dxHtmlEditor' },
            ]
        };

        this.state = {
            rejectOptions: initialOptions
        };

    }
    onCheckboxValueChanged = (field, value) => {
        const anyWasSelected = this.rejectOptions.some(type => this.state.rejectOptions[type.field] === true);
        this.state.rejectOptions[field] = value;

        //FIRST ITEM SELECTED
        if (anyWasSelected === false && value === true) {
            //CLEAR ANY VALIDATION ERRORS ON OTHER BOXES
            this.rejectOptions.forEach(itm => {
                if (itm.field !== field) {
                    itm.validatorRef.current.instance().reset()
                }
            });
        }
        this.props.fieldChanged(field, value);
    }
    renderCheckboxes = () => {
        return (
            <div style={{ display: 'flex', flexDirection: 'column' }}>
                {
                    this.rejectOptions.map((option, index) =>
                    (
                        <CheckBox
                            key={index}
                            style={{ marginTop: 7, marginBottom: 4 }}
                            defaultValue={this.state.rejectOptions[option.field] ? this.state.rejectOptions[option.field] : false}
                            onValueChanged={(args) => this.onCheckboxValueChanged(option.field, args.value)}
                            text={option.display} >
                            <Validator ref={option.validatorRef}>
                                <CustomRule
                                    type="custom"
                                    validationCallback={(e) => {
                                        if (e.value === true) { return true; }
                                        const validationresult = this.rejectOptions.some(opt => this.state.rejectOptions[opt.field] === true && opt.field !== option.field);
                                        return validationresult;
                                    }}
                                    message={this.props.intl.formatMessage({ id: 'GENERAL.FORMS.WARNING.ONE_OPTION_REQUIRED' })}
                                />
                            </Validator>
                        </CheckBox>
                    ))
                }
            </div>
        );
    }

    renderChackedRejectItems = () => {
        const items = this.rejectOptions.filter(itm => (this.props.notification[itm.field] && this.props.notification[itm.field] === 1));
        return (
            <ul style={{ listStyleType: 'none', paddingInlineStart: 0 }}>
                {items.map((item, index) => (
                    <li key={index}>
                        <i className="fas fa-chevron-right"></i>
                        <span style={{ paddingLeft: 5 }}>{item.display}</span>
                    </li>
                ))}
            </ul>
        );
    }



    renderForm = () => {
        return (
            <BiDynamicForm
                isReply={true}
                item={this.props.reply}
                config={this.replyFormConfig}
                valueChangeHandler={this.props.fieldChanged}
                customFields={(this.props.customFields || {}).REPLY}
            />
        );
    }
    uploadFile = (data, config) => {
        const { companyid, projectid, contractid } = this.props.contract;
        return fileCrud.uploadContractNotificationFiles(companyid, projectid, contractid, this.props.documentType + 'Reply', this.props.notification.programid, this.props.workflowItem.id, this.props.workflowItem.config.quotationWorkflowID, data, config)
    }
    render() {
        const documentIsFinal = !this.props.isAwaitingReply;
        const { replycreatebyname, replycreatedate, draftreplyby, draftreplydate, draftreplyto } = this.props.notification;



        return (
            <>
                <DocumentDraftInfo
                    documentIsFinal={documentIsFinal}
                    createbyname={replycreatebyname}
                    createdate={replycreatedate}
                    lastdraftedbyname={draftreplyby}
                    lastdrafteddate={draftreplydate}
                    lastdraftednotifiedtoname={draftreplyto}
                    isReply={true}
                />
                <Document
                    key={documentIsFinal}
                    docConfig={this.props.notification.pdfreplyjsoncontent}
                    isFinal={documentIsFinal}
                    printDivRef={this.props.printDivRef}
                    workflowItem={this.props.workflowItem}
                    contract={this.props.contract}
                    reference={this.props.notification.referenceid}
                    form={documentIsFinal ? null : this.renderForm()}
                    uploadMethod={documentIsFinal ? null : this.uploadFile}
                    files={this.props.files}
                    notificationid={this.props.notificationid}
                    documentType={this.props.documentType}
                    isReply={true}
                    customFields={(this.props.customFields || {}).REPLY}
                    customFieldValues={this.props.notification.customfieldvalues}
                    assetid={this.props.notification.assetid}
                    saving={this.props.saving}
                    onFileUploadFinish={this.props.onFileUploadFinish}
                    onFileUploadStart={this.props.onFileUploadStart}
                />
            </>
        );

    }
}


export default injectIntl(ReplyDocument);
